import React from 'react';
import { Tab } from '@headlessui/react';
import { useTranslation } from 'react-i18next';
import CargomaticTab from '../../v2/navs/Tab';
import Alert from '../../ui/Alert';
import SessionStore from '../../../stores/SessionStore';
import Milestones from './edi/Milestones';
import Invoices from './edi/Invoices';
import CarrierEdiEvents from './edi/CarrierEdiEvents';
export default function EDIResender() {
    const { t } = useTranslation();
    const tabs = [
        {
            slug: 'milestones',
            name: t('MILESTONES'),
        },
        {
            slug: 'invoices',
            name: t('INVOICE', { count: 2 }),
        },
        {
            slug: 'carrier',
            name: t('CARRIER_EVENTS'),
        },
    ];
    function renderTabs() {
        return (React.createElement(Tab.Group, null,
            React.createElement(Tab.List, null,
                React.createElement("div", { className: "space-x-4" }, tabs.map((tab) => (React.createElement(CargomaticTab, { tab: tab }))))),
            React.createElement(Tab.Panels, { className: "mt-6" },
                React.createElement(Tab.Panel, null,
                    React.createElement(Milestones, null)),
                React.createElement(Tab.Panel, null,
                    React.createElement(Invoices, null)),
                React.createElement(Tab.Panel, null,
                    React.createElement(CarrierEdiEvents, null)))));
    }
    if (!(SessionStore.isGodAdmin() || SessionStore.hasIntegrationManagerRole())) {
        return (React.createElement(React.Fragment, null,
            React.createElement("h3", { key: "heading", className: "my-0 mb-4" }, t('RESEND_EDI')),
            ",",
            React.createElement(Alert, { key: "alert", type: "error" }, t('NOT_AUTHORIZED'))));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("h3", { className: "my-0 mb-4" }, t('RESEND_EDI')),
        renderTabs()));
}
